// @owners { team: patient-fulfillment }
import { type OrderPricingParams } from '@alto/scriptdash/alto/pricing/patients/v3/pricing_endpoint';
import { createSelector } from 'reselect';
import { getOrder } from '~shared/features/checkout/selectors/getOrder';
import { type Order } from '~shared/features/checkout/types';
import { makeFetchOrderPricingOrderParam } from '~shared/features/pricing/helpers';

export const getFetchPricingOrderParam = createSelector([getOrder], (order: Order): OrderPricingParams => {
  return makeFetchOrderPricingOrderParam(order);
});
